import { Contract } from '../model/contract';

export default class ExportUtils {

    /**
     * Calculates article number, skipping non-enumerated articles.
     */
    static getArticleNumber(contract: Contract, index: number) {
        return contract.articles.slice(0, index).filter(a => !a.dummy).length + 1;
    }

    /**
     * Converts number to it's roman numerals equivalent representation.
     * Source: http://blog.stevenlevithan.com/archives/javascript-roman-numeral-converter
     * @param num Number to covert.
     */
    static romanize(num) {
        if (!+num)
            return NaN;
        var digits = String(+num).split(""),
            key = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM",
                "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC",
                "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"],
            roman = "",
            i = 3;
        while (i--)
            roman = (key[+digits.pop() + (i * 10)] || "") + roman;
        return Array(+digits.join("") + 1).join("M") + roman;
    }

}



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/utils/export.ts